<template>
  <page-container @window-return="refresh">
    <search-bar :items="[
      { key: 'category_ids', label: 'Categories', type: 'categroup' },
      { key: 'part_no_search', label: 'Part Number', type: 'input', width: 260 },
      { key: 'description', label: 'Description', type: 'multi', width: 260 },
      { key: 'brand', label: 'Brand', type: 'multi', width: 160 },
      { key: 'oper_time', label: 'Time', type: 'timerange' },
      { key: 'location', label: 'Location', type: 'select', state: 'stock_location', width: 100 },
      { key: 'show_detail', label: 'Stock Detail', type: 'checkbox' },
      { key: 'stock_qty', label: 'Stock Qty >=', type: 'input', width: 80, placeholder: '0' }
    ]" @search="search"/>

    <div class="card">
      <div flex>
        <div>
          <!--
          <el-button round size="small" icon="el-icon-printer" @click="print">Print</el-button>
          -->
          <el-button round size="small" icon="el-icon-document">To Excel</el-button>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>

      <cate-table :columns="[
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'stock_bb', title: 'BB Bal.' },
        { key: 'stock_hk', title: 'HK Bal.' },
        { key: 'stock_sz', title: 'SZ Bal.' },
        { key: 'incoming_qty', title: 'Incoming.' },
        { key: 'reserved_qty', title: 'Reserved.' },
        { key: 'stock_remark', title: 'Remark' }
      ]"
      :data="list"
      :loading="loading"
      show-detail
      show-cart
      @detail-click="$open(`/product/${arguments[0]}/details`)"
      @part-click="$open(`/product/${arguments[0]}/stock`)"
      style="margin:10px 0;" />

      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </page-container>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'stock_list'
    }
  }
}
</script>
